import type { FC } from 'react'
import cn from 'classnames'
import type { ToastProps, ToasterContainerProps } from '.'
import s from './toast.module.css'

export const ToastContainer: FC<ToasterContainerProps> = ({ className, ...props }) => {
  return <div className={cn(s.container, className)} {...props} />
}

const Toast: FC<ToastProps> = ({ onDismiss, toast }) => {
  const { title, description, type } = toast
  return (
    <button type="button" className={cn(s.root, s[type])} onClick={onDismiss}>
      <div className={s.content}>
        <div className={s.title}>{title}</div>
        {description && <div className={s.description}>{description}</div>}
      </div>
      <button type="button" className={s.close}>
        &times;
      </button>
    </button>
  )
}

export default Toast
